import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { extractRefFromUrl, storeReferralCode } from '../utils/referralStorage';

/**
 * Watches the URL for a ?ref=CODE query param on ANY route and persists it
 * to localStorage via referralStorage. This fixes the bug where a user who
 * landed via a referrer's link, browsed the site, and then registered from
 * /register (without ?ref in the URL) was not linked to the referrer.
 *
 * Must be rendered inside <Router> (uses useLocation). Renders nothing.
 *
 * Why a dedicated component (not inline in App.js):
 *  - Mirrors the ScrollToTop pattern already established in this codebase.
 *  - Keeps App.js declarative — App composes behaviors, doesn't implement them.
 *  - Unit-testable in isolation without mounting the whole provider tree.
 */
function ReferralCapture() {
  const { search } = useLocation();

  useEffect(() => {
    const code = extractRefFromUrl(search);
    if (code) {
      storeReferralCode(code);
    }
  }, [search]);

  return null;
}

export default ReferralCapture;
